
import { default as axios } from 'axios';
import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { ISnapshotHypermediaRepresentation } from '../../shared/contracts/SnapshotContract';
import { IAggregateState } from '../../store/contract';
import store from '../../store/store';
const aggregateNamespace = 'aggregate';

@Component({})
export default class SearchBar extends Vue {
    @State(aggregateNamespace) aggregateState: IAggregateState;

    private actionSnapshots: ISnapshotHypermediaRepresentation[] = [];
    private searchTarget: Vue = null;
    private searchedPerson: ISnapshotHypermediaRepresentation = null;

    async created(): Promise<void> {
        await store.dispatch('aggregate/fetchAllAggregate');
        this.retrieveActionSnapshots();
    }

    mounted(): void {
        this.searchTarget = this.$refs.searchInput as Vue;
    }

    onPersonSelected(): void {
        if (this.searchedPerson) {
            this.$router.push({
                name: 'barometer',
                params: {
                    personId: this.searchedPerson.participantId.toString()
                }
            });
            this.searchedPerson = null;
        }
    }

    protected async retrieveActionSnapshots(): Promise<void> {
        const response = await axios.get<ISnapshotHypermediaRepresentation[]>(
            this.aggregateState.allAggregateItem._links.item_people_actions.href
        );
        this.actionSnapshots = response.data;
    }
}
